import { Ipage } from 'components/Table/type';
import { Ioption } from 'tradevan-ui/type';
import { EnumRetailerSetup, EnumRetailerType } from 'view/Layout/enum';
import { getUserInfoReducer } from 'reducer/common/userInfo';
import { useSelector } from 'react-redux';
import { localStorageRetaierIdName, DATE_RANGE_DEFAULT } from 'consts';
import { IexportItemList, IqueryDateList, IquerySort } from 'view/Layout/type';
import { initExportItemList } from 'view/Layout/consts';
import { IlogRecordQuery } from '../components/LogRecordModal/type';

// #region Master

export const EnumMaster = {
  /** 體系別 */
  retailerId: 'retailerId',
  /** 廠編 */
  supplierCode: 'supplierCode',
  /** 分店/倉庫代碼 */
  storeNo: 'storeNo',
  /** 訂單日期 起 */
  orderDateBegin: 'orderDateBegin',
  /** 訂單日期 訖 */
  orderDateEnd: 'orderDateEnd',
  /** 到貨日期 起 */
  deliverDateBegin: 'deliverDateBegin',
  /** 到貨日期 訖 */
  deliverDateEnd: 'deliverDateEnd',
  /** 訂單號碼 起 */
  orderNoBegin: 'orderNoBegin',
  /** 訂單號碼 訖 */
  orderNoEnd: 'orderNoEnd',
  /** 未點閱列印勾選 */
  isNoViewedPrintFlag: 'isNoViewedPrintFlag',
  /** 廠編模糊篩選 */
  supplierCodeLike: 'supplierCodeLike',
  /** 日期下拉選單 */
  queryDateValue: 'queryDateValue',
  /** 動態日期 起 */
  queryDateBegin: 'queryDateBegin',
  /** 動態日期 迄 */
  queryDateEnd: 'queryDateEnd',
} as const;

export interface Imaster {
  [EnumMaster.retailerId]: EnumRetailerType | string;
  [EnumMaster.supplierCode]: string[];
  [EnumMaster.storeNo]: string[];
  [EnumMaster.orderDateBegin]: Date | null;
  [EnumMaster.orderDateEnd]: Date | null;
  [EnumMaster.deliverDateBegin]: Date | null;
  [EnumMaster.deliverDateEnd]: Date | null;
  [EnumMaster.orderNoBegin]: string;
  [EnumMaster.orderNoEnd]: string;
  [EnumMaster.isNoViewedPrintFlag]: string | null;
  [EnumMaster.supplierCodeLike]: string;
  [EnumMaster.queryDateValue]: string | null;
  [EnumMaster.queryDateBegin]: Date | null;
  [EnumMaster.queryDateEnd]: Date | null;
}

// #endregion

// #region Detail

export enum EnumDetail {
  /** 體系別 */
  retailerId = 'retailerId',
  /** 體系別中文 */
  retailerName = 'retailerName',
  /** 分店/倉庫名稱 */
  buyerGLN = 'buyerGLN',
  /** 訂單號碼 */
  orderNo = 'orderNo',
  /** 訂單日期 */
  orderDate = 'orderDate',
  /** 廠編 */
  supplierCode = 'supplierCode',
  /** 廠商簡稱 */
  supplierBriefName = 'supplierBriefName',
  /** 採購組織 */
  typeName = 'typeName',
  /** 合約號碼 */
  buildNo = 'buildNo',
  /** 送貨截止日 */
  deliverEndDate = 'deliverEndDate',
  /** 送貨期間 */
  deliverStartDate = 'deliverStartDate',
  deliverStartTime = 'deliverStartTime',
  /** 訂單狀態 */
  orderStatus = 'orderStatus',
  /** 點閱紀錄 */
  viewed = 'viewed',
  /** 文字檔下載紀錄 */
  downloaded = 'downloaded',
  /** 最後異動時間 */
  updDate = 'updDate',
  version = 'version',
  deliverEndTime = 'deliverEndTime',
  /** 訂單有效日 */
  orderExpireDate = 'orderExpireDate',
  orderSeqNo = 'orderSeqNo',
  postBriefName = 'postBriefName',
  propName = 'propName',
  reportType = 'reportType',
  saleType = 'saleType',
  transDate = 'transDate',
  upFlag = 'upFlag',
  /** 訂單屬性 */
  orderType = 'orderType',
  /** 備註 */
  announcement = 'announcement',
}

export interface Idetail {
  [EnumDetail.buildNo]: string;
  [EnumDetail.buyerGLN]: string;
  [EnumDetail.deliverEndDate]: string;
  [EnumDetail.deliverEndTime]: string;
  [EnumDetail.deliverStartDate]: string;
  [EnumDetail.deliverStartTime]: string;
  [EnumDetail.downloaded]: string;
  [EnumDetail.orderDate]: string;
  [EnumDetail.orderExpireDate]: string;
  [EnumDetail.orderNo]: string;
  [EnumDetail.orderSeqNo]: string;
  [EnumDetail.orderStatus]: string;
  [EnumDetail.postBriefName]: string;
  [EnumDetail.propName]: string;
  [EnumDetail.reportType]: string;
  [EnumDetail.retailerId]: string;
  [EnumDetail.retailerName]: string;
  [EnumDetail.saleType]: string;
  [EnumDetail.supplierCode]: string;
  [EnumDetail.supplierBriefName]: string;
  [EnumDetail.transDate]: string;
  [EnumDetail.typeName]: string;
  [EnumDetail.updDate]: string;
  [EnumDetail.upFlag]: string;
  [EnumDetail.viewed]: string;
  [EnumDetail.version]: string;
  [EnumDetail.orderType]: string;
  [EnumDetail.announcement]: string;
  selected: boolean; // checkbox 是否勾選
  selectHidden: boolean; // checkbox 是否顯示
}

// #endregion

// #region MasterSort

// #endregion

// #region retailerSetup

export enum EnumQueryConditions {
  retailerId = 'retailerId',
  supplierCode = 'supplierCode',
  storeNo = 'storeNo',
  orderDate = 'orderDate',
  deliverDate = 'deliverDate',
  orderNo = 'orderNo',
  supplierCodeLike = 'supplierCodeLike',
  queryDateSelect = 'queryDateSelect',
  queryDateBegin = 'queryDateBegin',
  queryDateEnd = 'queryDateEnd',
}
export interface IqueryConditions {
  [EnumQueryConditions.retailerId]: boolean;
  [EnumQueryConditions.supplierCode]: boolean;
  [EnumQueryConditions.storeNo]: boolean;
  [EnumQueryConditions.orderDate]: boolean;
  [EnumQueryConditions.orderNo]: boolean;
  [EnumQueryConditions.deliverDate]: boolean;
  [EnumQueryConditions.supplierCodeLike]: boolean;
  [EnumQueryConditions.queryDateSelect]: boolean;
}

export enum EnumQueryResults {
  /** 分店/倉庫名稱 */
  storeNo = 'storeNo',
  /** 訂單號碼 */
  orderNo = 'orderNo',
  /** 訂單日期 */
  orderDate = 'orderDate',
  /** 廠編 */
  supplierCode = 'supplierCode',
  /** 廠商簡稱 */
  supplierBriefName = 'supplierBriefName',
  /** 採購組織 */
  typeName = 'typeName',
  /** 合約號碼 */
  buildNo = 'buildNo',
  /** 送貨期間 */
  deliverDate1 = 'deliverDate1',
  /** 送貨期間 */
  deliverDate2 = 'deliverDate2',
  /** 訂單有效日 */
  orderExpireDate = 'orderExpireDate',
  /** 送貨起始日 */
  deliverStartDate = 'deliverStartDate',
  /** 送貨截止日 */
  deliverEndDate = 'deliverEndDate',
  /** 訂單狀態 */
  orderStatus = 'orderStatus',
  /** 點閱紀錄 */
  viewed = 'viewed',
  /** 文字檔下載紀錄 */
  downloaded = 'downloaded',
  /** 最後異動時間 */
  updDate = 'updDate',
  /** 訂單屬性 */
  orderType = 'orderType',
  /** 備註 */
  announcement = 'announcement',
}

export interface IqueryResults {
  [EnumQueryResults.storeNo]: boolean;
  [EnumQueryResults.orderNo]: boolean;
  [EnumQueryResults.orderDate]: boolean;
  [EnumQueryResults.supplierCode]: boolean;
  [EnumQueryResults.supplierBriefName]: boolean;
  [EnumQueryResults.typeName]: boolean;
  [EnumQueryResults.buildNo]: boolean;
  [EnumQueryResults.deliverDate1]: boolean;
  [EnumQueryResults.deliverDate2]: boolean;
  [EnumQueryResults.orderExpireDate]: boolean;
  [EnumQueryResults.deliverStartDate]: boolean;
  [EnumQueryResults.deliverEndDate]: boolean;
  [EnumQueryResults.orderStatus]: boolean;
  [EnumQueryResults.viewed]: boolean;
  [EnumQueryResults.downloaded]: boolean;
  [EnumQueryResults.updDate]: boolean;
  [EnumQueryResults.orderType]: boolean;
  [EnumQueryResults.announcement]: boolean;
}

export interface IretailerSetupOrder {
  [EnumRetailerSetup.queryConditions]: IqueryConditions;
  [EnumRetailerSetup.queryResults]: IqueryResults;
  [EnumRetailerSetup.exportItemList]: IexportItemList;
  [EnumRetailerSetup.queryDateList]: IqueryDateList[];
}

// #endregion

// #region Form

export interface QueryOrderForm {
  master: Imaster;
  masterSort: IquerySort[];
}

export interface QueryOrderFormDetail {
  pageObj: Ipage;
  master: Imaster;
  detail: Idetail[];
  masterSort: IquerySort[];
}

// #endregion

// #region state

export interface QueryReturnState {
  /** input */
  master: Imaster;
  /** form的排序 */
  masterSort: IquerySort[];

  detail: Idetail[];
  pageObj: Ipage;
  /** 體系別option */
  retailerTypeOption: Ioption[];

  showResult: boolean;
  /** 操作歷程 畫面開關 */
  showLogRecordModal: boolean;
  /** 操作歷程 資料 */
  logRecordData: IlogRecordQuery[];
  /** 是否勾選未點閱列印查詢 */
  isNoViewedPrint: boolean;
  /** 未點閱列印查詢提示訊息 */
  isNoViewedPrintMessage: string;
  queryDateList: IqueryDateList[];
}
export enum EnumQueryDateSelect {
  選項值 = 'optionId',
  選項名稱 = 'propertyName',
  預設起始天數 = 'beginDate',
  預設結束天數 = 'endDate',
}

// #endregion

// #region useInit
export const useInitMaster = (): Imaster => {
  // 取得 retailerIds (動態變動) 所以要使用 useEffect 更新 Master
  const { retailerIds } = useSelector(getUserInfoReducer);
  // 舊系統轉移到新系統，retaierId會記錄到 localStorage
  // 如果沒有 localStorage 就取 retailerIds 的第一比當體系別預設值
  const defaultRetaierId =
    localStorage.getItem(localStorageRetaierIdName) ||
    retailerIds?.[0]?.retailerId ||
    '';

  return {
    [EnumMaster.retailerId]: defaultRetaierId,
    [EnumMaster.supplierCode]: [],
    [EnumMaster.storeNo]: [],
    [EnumMaster.orderNoBegin]: '',
    [EnumMaster.orderNoEnd]: '',
    [EnumMaster.orderDateBegin]: DATE_RANGE_DEFAULT.startDate,
    [EnumMaster.orderDateEnd]: DATE_RANGE_DEFAULT.endDate,
    [EnumMaster.deliverDateBegin]: DATE_RANGE_DEFAULT.startDate,
    [EnumMaster.deliverDateEnd]: DATE_RANGE_DEFAULT.endDate,
    [EnumMaster.isNoViewedPrintFlag]: 'N',
    [EnumMaster.supplierCodeLike]: '',
    [EnumMaster.queryDateValue]: '',
    [EnumMaster.queryDateBegin]: DATE_RANGE_DEFAULT.startDate,
    [EnumMaster.queryDateEnd]: DATE_RANGE_DEFAULT.endDate,
  };
};

// #endregion

// #region retailerSetup 控制畫面顯示

export const useInitRetailerSetup = (): IretailerSetupOrder => ({
  [EnumRetailerSetup.queryConditions]: {
    [EnumQueryConditions.retailerId]: true,
    [EnumQueryConditions.supplierCode]: false,
    [EnumQueryConditions.storeNo]: false,
    [EnumQueryConditions.orderDate]: false,
    [EnumQueryConditions.deliverDate]: false,
    [EnumQueryConditions.orderNo]: false,
    [EnumQueryConditions.supplierCodeLike]: false,
    [EnumQueryConditions.queryDateSelect]: false,
  },
  [EnumRetailerSetup.queryResults]: {
    [EnumQueryResults.storeNo]: true,
    [EnumQueryResults.orderNo]: true,
    [EnumQueryResults.orderDate]: true,
    [EnumQueryResults.supplierCode]: false,
    [EnumQueryResults.supplierBriefName]: false,
    [EnumQueryResults.typeName]: false,
    [EnumQueryResults.buildNo]: false,
    [EnumQueryResults.deliverDate1]: false,
    [EnumQueryResults.deliverDate2]: false,
    [EnumQueryResults.orderExpireDate]: false,
    [EnumQueryResults.deliverStartDate]: false,
    [EnumQueryResults.deliverEndDate]: false,
    [EnumQueryResults.orderStatus]: false,
    [EnumQueryResults.viewed]: false,
    [EnumQueryResults.downloaded]: false,
    [EnumQueryResults.updDate]: true,
    [EnumQueryResults.orderType]: false,
    [EnumQueryResults.announcement]: false,
  },
  [EnumRetailerSetup.exportItemList]: initExportItemList,
  [EnumRetailerSetup.queryDateList]: [],
});
// #endregion
